/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomAppState } from "@rc/App/Store/Reducers";
import { getSettingsCollection } from "@rc/App/Store/Selectors/SettingsSelectors";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    return {
        oneTrustJsLink: (getSettingsCollection(state).customSetting as any)?.oneTrustJsLink,
        oneTrustJsDataDomain: (getSettingsCollection(state).customSetting as any)?.oneTrustJsDataDomain,
        cookieSettingsButtonPosition: (getSettingsCollection(state).customSetting as any)?.cookieSettingsButtonPosition,
    };
};

type Props = ReturnType<typeof mapStateToProps>;

export interface OneTrustStyles {
    container?: InjectableCss;
    cookiesButton?: ButtonPresentationProps;
}

export const oneTrustStyles: OneTrustStyles = {};

const OneTrust = ({ oneTrustJsLink, oneTrustJsDataDomain, cookieSettingsButtonPosition }: Props) => {
    const styles = oneTrustStyles;

    useEffect(() => {
        if ((window as any).cookieScriptAdded) {
            return;
        }

        const script = document.createElement("script");
        script.src = oneTrustJsLink;
        script.setAttribute("data-domain-script", oneTrustJsDataDomain);
        script.async = true;

        document.body.appendChild(script);
        (window as any).cookieScriptAdded = true;
    }, []);

    return (
        <StyledWrapper {...styles.container} className={cookieSettingsButtonPosition}>
            <StyledWrapper className="one-trust">
                <Button variant="secondary" id="ot-sdk-btn" className="ot-sdk-show-settings" {...styles.cookiesButton}>
                    {translate("Cookies Settings")}
                </Button>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(OneTrust);
